<template>
  <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
    <el-tab-pane label="消息列表" name="first">
      <div class="main">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-select v-model="queryData.noticeType" placeholder="消息类型">
                <el-option label="请选择消息类型" value="0"></el-option>
                <el-option label="系统消息" value="1"></el-option>
                <el-option label="活动消息" value="2"></el-option>
              </el-select>
              <el-input v-model="queryData.noticeTitle"  placeholder="请输入消息标题"></el-input>
              <el-input v-model="queryData.noticeContent"  placeholder="请输入消息内容"></el-input>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
              <el-button type="primary" @click="clickdialogAdd">新增</el-button>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="noticeType" label="消息类型" width="100" sortable="custom">
              <template slot-scope="props">
                <span v-if="props.row.noticeType == 1">系统消息</span>
                <span v-if="props.row.noticeType == 2">活动消息</span>
              </template>
            </el-table-column>
            <el-table-column prop="noticeTitle" label="消息标题" min-width="150" sortable="custom"></el-table-column>
            <el-table-column prop="noticeContent" label="消息内容" min-width="200" sortable="custom"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" sortable="custom"></el-table-column>
            <el-table-column label="英文标题" min-width="120">
              <template slot-scope="scope">
                <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['notice_title']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="德文标题" min-width="120">
              <template slot-scope="scope">
                <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['notice_title']) || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Operation" label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-delete" class="mr12" @click="ClickDelete(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="翻译" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-s-opportunity" class="mr12" @click="clickI18n(scope.row)"></el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

        <!---------------------- 以下是弹框内容 ---------------------->
        <!-- 添加消息 -->
        <el-dialog title="添加消息" :visible.sync="dialogAdd" width="26%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="addData" label-width="80px">
              <el-form-item label="消息类型" :required=true>
                <el-select v-model="addData.noticeType" placeholder="消息类型">
                  <el-option label="系统消息" value="1"></el-option>
                  <el-option label="活动消息" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="消息标题" :required=true>
                <el-input v-model="addData.noticeTitle" placeholder="请输入消息标题"></el-input>
              </el-form-item>
              <el-form-item label="消息内容" :required=true>
                <el-input v-model="addData.noticeContent" placeholder="请输入消息内容"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="NoticeInsert()" >确 认</el-button>
            <el-button @click="dialogAdd = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 添加消息 End -->

        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="editData" label-width="80px">
              <el-form-item label="消息类型" :required=true>
                <el-select v-model="editData.noticeType" placeholder="消息类型">
                  <el-option label="系统消息" value="1"></el-option>
                  <el-option label="活动消息" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="消息标题" :required=true>
                <el-input v-model="editData.noticeTitle" placeholder="请输入消息标题"></el-input>
              </el-form-item>
              <el-form-item label="消息内容" :required=true>
                <el-input v-model="editData.noticeContent" placeholder="请输入消息内容"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="NoticeUpdate()" >确 认</el-button>
            <el-button @click="dialogEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

        <!-- 删除 -->
        <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
          <div class="confirmMsg">确定删除？</div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="NoticeDelete" >确 定</el-button>
            <el-button @click="dialogDel = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 删除 End -->

        <!-- 翻译管理 -->
        <i18n-translation-dialog
          :visible.sync="dialogI18n"
          :entity-type="i18nEntityType"
          :entity-id="i18nEntityId"
          :fields="i18nFields">
        </i18n-translation-dialog>

      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: { I18nTranslationDialog },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        noticeType: '0',
        noticeTitle: '',
        noticeContent: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        noticeType: '1',
        noticeTitle: '',
        noticeContent: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        noticeType: '',
        noticeTitle: '',
        noticeContent: ''
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false,
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'NOTICE',
      i18nFields: [
        { name: 'notice_title', label: '消息标题', type: 'input' },
        { name: 'notice_content', label: '消息内容', type: 'textarea' }
      ],
      translationMap: {}
    }
  },
  mounted () {
    this.NoticeList()
    this.NoticeNum()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.NoticeList()
      this.NoticeNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.NoticeList()
      this.NoticeNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.NoticeList()
      this.NoticeNum()
    },
    clickQuery () {
      this.page_no = 1
      this.NoticeList()
      this.NoticeNum()
    },
    clickQueryReset () {
      this.queryData.noticeType = '0'
      this.queryData.noticeTitle = ''
      this.queryData.noticeContent = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.noticeType = '1'
      this.addData.noticeTitle = ''
      this.addData.noticeContent = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.notice = row.notice
      this.editData.noticeType = row.noticeType.toString()
      this.editData.noticeTitle = row.noticeTitle
      this.editData.noticeContent = row.noticeContent
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    NoticeList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryData.noticeType
      data.noticeTitle = that.queryData.noticeTitle
      data.noticeContent = that.queryData.noticeContent
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('NOTICE', that.dataList, 'id')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.queryData.noticeType
      data.noticeTitle = that.queryData.noticeTitle
      data.noticeContent = that.queryData.noticeContent
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    NoticeInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.noticeType = that.addData.noticeType
      data.noticeTitle = that.addData.noticeTitle
      data.noticeContent = that.addData.noticeContent
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeList()
            that.NoticeNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    NoticeUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.noticeType = that.editData.noticeType
      data.noticeTitle = that.editData.noticeTitle
      data.noticeContent = that.editData.noticeContent
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeList()
            that.NoticeNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      this.dialogI18n = true
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    NoticeDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_NoticeDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.NoticeList()
            that.NoticeNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    }
  },
  watch: {
    dialogI18n (val) {
      if (!val) {
        this.loadTranslations('NOTICE', this.dataList, 'id')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
